import React, { useEffect, useState } from "react";
import { ExternalLink, Loader2, CheckCircle2, Sparkles, CalendarCheck } from "lucide-react";
import api from "@/lib/api";

const STATUS_META = {
  applied: { label: "Applied", classes: "bg-slate-500/10 text-slate-300", icon: CheckCircle2 },
  interview_invited: { label: "Interview Invited", classes: "bg-emerald-400/10 text-emerald-300", icon: CalendarCheck },
};

export default function MyApplicationsList() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/jobs/me/applications").then((r) => setApplications(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="flex justify-center py-10" data-testid="my-applications-loading"><Loader2 className="w-5 h-5 text-indigo-400 animate-spin" /></div>;
  }

  if (applications.length === 0) {
    return (
      <div className="glass-panel rounded-2xl p-10 text-center" data-testid="my-applications-empty">
        <p className="text-slate-400 text-sm">You haven't applied to any jobs yet. Browse jobs and hit Apply to track them here.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="my-applications-list">
      {applications.map((a) => {
        const meta = STATUS_META[a.status] || STATUS_META.applied;
        const StatusIcon = meta.icon;
        return (
          <div key={a.id} className="glass-panel rounded-xl p-4 flex items-center justify-between gap-4 flex-wrap" data-testid={`my-application-${a.id}`}>
            <div>
              <p className="text-sm font-semibold text-white">{a.job_title} <span className="text-indigo-400">· {a.company}</span></p>
              <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                <span className={`flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full ${meta.classes}`} data-testid={`my-application-status-${a.id}`}>
                  <StatusIcon className="w-3 h-3" /> {meta.label}
                </span>
                {a.source === "auto_apply" && (
                  <span className="flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full bg-indigo-400/10 text-indigo-300">
                    <Sparkles className="w-3 h-3" /> AI Matched · {a.match_score}%
                  </span>
                )}
                <span className="text-[11px] text-slate-500">{new Date(a.created_at).toLocaleDateString()}</span>
              </div>
              {a.cover_note && <p className="text-xs text-slate-400 mt-2 leading-relaxed">{a.cover_note}</p>}
            </div>
            {a.apply_url && (
              <a href={a.apply_url} target="_blank" rel="noopener noreferrer" data-testid={`my-application-apply-link-${a.id}`}
                className="shrink-0 flex items-center gap-1.5 text-xs font-semibold text-indigo-300 hover:text-indigo-200">
                View Posting <ExternalLink className="w-3 h-3" />
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
}
